import * as actionTypes from "./actionTypes";

const initialState = {
  cancellations: [],
  providerCancellations: [],
  statistics: null,
  loading: false,
  error: null,
  fineLoading: false,
  fineError: null,
};

const cancellationsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch all cancellations
    case actionTypes.FETCH_ALL_CANCELLATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.FETCH_ALL_CANCELLATIONS_SUCCESS:
      return {
        ...state,
        cancellations: action.payload,
        loading: false,
        error: null,
      };

    case actionTypes.FETCH_ALL_CANCELLATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch provider cancellations
    case actionTypes.FETCH_PROVIDER_CANCELLATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.FETCH_PROVIDER_CANCELLATIONS_SUCCESS:
      return {
        ...state,
        providerCancellations: action.payload,
        loading: false,
        error: null,
      };

    case actionTypes.FETCH_PROVIDER_CANCELLATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Apply fine
    case actionTypes.APPLY_CANCELLATION_FINE_REQUEST:
      return {
        ...state,
        fineLoading: true,
        fineError: null,
      };

    case actionTypes.APPLY_CANCELLATION_FINE_SUCCESS:
      return {
        ...state,
        cancellations: state.cancellations.map((c) =>
          c.id === action.payload.id ? action.payload : c
        ),
        fineLoading: false,
        fineError: null,
      };

    case actionTypes.APPLY_CANCELLATION_FINE_FAILURE:
      return {
        ...state,
        fineLoading: false,
        fineError: action.payload,
      };

    // Update status
    case actionTypes.UPDATE_CANCELLATION_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.UPDATE_CANCELLATION_STATUS_SUCCESS:
      return {
        ...state,
        cancellations: state.cancellations.map((c) =>
          c.id === action.payload.id ? action.payload : c
        ),
        loading: false,
        error: null,
      };

    case actionTypes.UPDATE_CANCELLATION_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Fetch statistics
    case actionTypes.FETCH_CANCELLATION_STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.FETCH_CANCELLATION_STATISTICS_SUCCESS:
      return {
        ...state,
        statistics: action.payload,
        loading: false,
        error: null,
      };

    case actionTypes.FETCH_CANCELLATION_STATISTICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default cancellationsReducer;
